// @ts-ignore
import { setupLayouts } from 'virtual:generated-layouts'
import NProgress from 'nprogress'
import {
	routes as generatedRoutes,
	handleHotUpdate
} from 'vue-router/auto-routes'
import { createRouter, createWebHistory } from 'vue-router'

NProgress.configure({ showSpinner: false })

const routes = setupLayouts(generatedRoutes)

const router = createRouter({
	history: createWebHistory(),
	routes: [
		...routes,
		{
			path: '/',
			redirect: '/events'
		}
	],
	linkExactActiveClass: '!text-thunderbird-800'
})

router.beforeEach((to, from, next) => {
	const isAuthenticated = !!localStorage.getItem('authToken')
	NProgress.start()

	next()
})

router.afterEach(() => {
	NProgress.done()
})

if (import.meta.hot) {
	handleHotUpdate(router)
}

export default router
